import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e475a5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "breadcrumb" }
const _hoisted_2 = { class: "page-title-row" }
const _hoisted_3 = {
  key: 0,
  class: "page-strategy-row"
}
const _hoisted_4 = { class: "page-strategy-item" }
const _hoisted_5 = { class: "page-strategy-item" }
const _hoisted_6 = { class: "page-content" }
const _hoisted_7 = { class: "card-step-row" }
const _hoisted_8 = {
  key: 0,
  class: "card-step-factor-no-auth-hint"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("第二步：选股范围")
const _hoisted_10 = { class: "summary-body" }
const _hoisted_11 = { class: "summary-col" }
const _hoisted_12 = { class: "summary-item" }
const _hoisted_13 = { class: "summary-item" }
const _hoisted_14 = {
  class: "summary-value",
  style: {"color":"#e8392a"}
}
const _hoisted_15 = { class: "summary-item" }
const _hoisted_16 = { class: "summary-col" }
const _hoisted_17 = { class: "summary-item" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("—")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("查询中…")
const _hoisted_20 = {
  key: 3,
  class: "summary-tag"
}
const _hoisted_21 = { class: "summary-item" }
const _hoisted_22 = {
  class: "summary-value",
  style: {"color":"#00b578"}
}
const _hoisted_23 = { class: "summary-item summary-item--last" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "stock-dialog-body" }
const _hoisted_26 = { class: "stock-table" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 1,
  class: "group-toast"
}
const _hoisted_30 = {
  key: 2,
  class: "global-loading-mask"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StarTabBar = _resolveComponent("StarTabBar")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_FactorSelector = _resolveComponent("FactorSelector")!
  const _component_StockRangeSelector = _resolveComponent("StockRangeSelector")!
  const _component_TradingRules = _resolveComponent("TradingRules")!
  const _component_PositionControl = _resolveComponent("PositionControl")!
  const _component_BacktestPeriod = _resolveComponent("BacktestPeriod")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_StarTipDialog = _resolveComponent("StarTipDialog")!
  const _component_StarActivationDialog = _resolveComponent("StarActivationDialog")!
  const _component_StarXpGate = _resolveComponent("StarXpGate")!

  return (_openBlock(), _createBlock(_component_StarXpGate, { na: "starGroup" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "star-page",
        style: _normalizeStyle({ background: _ctx.isLight ? '#f0f2f5' : _ctx.colors.bg })
      }, [
        _createVNode(_component_StarTabBar, {
          modelValue: _ctx.activeTopTab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTopTab) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", {
          class: "page-header",
          style: _normalizeStyle({ background: _ctx.isLight ? '#ffffff' : '#1F1F1FB2', borderBottom: _ctx.isLight ? '1px solid #dbdfe6' : 'none' })
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", {
              class: "breadcrumb-item",
              style: _normalizeStyle({ color: _ctx.colors.textMuted }),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
            }, "首页", 4),
            _createElementVNode("span", {
              class: "breadcrumb-sep",
              style: _normalizeStyle({ color: _ctx.colors.textMuted })
            }, "›", 4),
            _createElementVNode("span", {
              class: "breadcrumb-item breadcrumb-current",
              style: _normalizeStyle({ color: _ctx.colors.textPrimary })
            }, _toDisplayString(_ctx.isPassword ? '组合量化(策略口令)' : '组合量化'), 5)
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", {
              class: "page-title",
              style: _normalizeStyle({ color: _ctx.colors.textPrimary })
            }, "组合量化", 4),
            _createElementVNode("span", {
              class: "page-desc",
              style: _normalizeStyle({ color: _ctx.colors.textMuted })
            }, "配置选股策略，验证历史表现", 4)
          ]),
          (_ctx.isPassword && _ctx.watchwordData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", {
                    class: "page-strategy-label",
                    style: _normalizeStyle({ color: _ctx.colors.textMuted })
                  }, "策略名称：", 4),
                  _createVNode(_component_a_tooltip, {
                    title: _ctx.strategyNameText,
                    placement: "topLeft",
                    "builtin-placements": _ctx.strategyBuiltinPlacements
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: "page-strategy-name",
                        style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                      }, _toDisplayString(_ctx.strategyNameText), 5)
                    ]),
                    _: 1
                  }, 8, ["title", "builtin-placements"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", {
                    class: "page-strategy-label",
                    style: _normalizeStyle({ color: _ctx.colors.textMuted })
                  }, "策略介绍：", 4),
                  _createVNode(_component_a_tooltip, {
                    title: _ctx.strategyNoteText,
                    placement: "topLeft",
                    "builtin-placements": _ctx.strategyBuiltinPlacements
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: "page-strategy-name",
                        style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                      }, _toDisplayString(_ctx.strategyNoteText), 5)
                    ]),
                    _: 1
                  }, 8, ["title", "builtin-placements"])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 4),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "section-card",
            style: _normalizeStyle({ background: _ctx.isLight ? '#ffffff' : '#1F1F1FB2' })
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: "card-step",
                style: _normalizeStyle({ color: _ctx.isLight ? '#1a1a1a' : '#D8D8DF' })
              }, "第一步：选股因子", 4),
              (_ctx.factorPasswordNoAuthHint)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.factorPasswordNoAuthHint), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.factorOptionsForDisplay)
              ? (_openBlock(), _createBlock(_component_FactorSelector, {
                  key: 0,
                  "factor-data": _ctx.factorOptionsForDisplay,
                  "initial-selection": _ctx.factorInitialSelection,
                  "is-light": _ctx.isLight,
                  colors: _ctx.colors,
                  headers: _ctx.factorHeaders,
                  onChange: _ctx.onFactorChange
                }, null, 8, ["factor-data", "initial-selection", "is-light", "colors", "headers", "onChange"]))
              : _createCommentVNode("", true)
          ], 4),
          _createElementVNode("div", {
            class: "section-card",
            style: _normalizeStyle({ background: _ctx.isLight ? '#ffffff' : '#1F1F1FB2' })
          }, [
            _createElementVNode("div", {
              class: "card-step",
              style: _normalizeStyle({ color: _ctx.isLight ? '#1a1a1a' : '#D8D8DF' })
            }, [
              _hoisted_9,
              _createElementVNode("span", {
                class: "card-step-hint",
                style: _normalizeStyle({ color: _ctx.colors.textMuted })
              }, "构建回测标的范围", 4)
            ], 4),
            (_ctx.stockRangeOptionsForDisplay)
              ? (_openBlock(), _createBlock(_component_StockRangeSelector, {
                  key: 0,
                  "range-data": _ctx.stockRangeOptionsForDisplay,
                  "initial-selection": _ctx.rangeInitialSelection,
                  headers: _ctx.factorHeaders,
                  "is-light": _ctx.isLight,
                  colors: _ctx.colors,
                  onChange: _ctx.onRangeChange
                }, null, 8, ["range-data", "initial-selection", "headers", "is-light", "colors", "onChange"]))
              : _createCommentVNode("", true)
          ], 4),
          _createElementVNode("div", {
            class: "section-card",
            style: _normalizeStyle({ background: _ctx.isLight ? '#ffffff' : '#1F1F1FB2' })
          }, [
            _createElementVNode("div", {
              class: "card-step",
              style: _normalizeStyle({ color: _ctx.isLight ? '#1a1a1a' : '#D8D8DF' })
            }, "第三步：选择买卖规则", 4),
            _createVNode(_component_TradingRules, {
              "is-light": _ctx.isLight,
              colors: _ctx.colors,
              "com-options": _ctx.comOptions,
              "initial-value": _ctx.watchwordData,
              onChange: _ctx.onTradingChange
            }, null, 8, ["is-light", "colors", "com-options", "initial-value", "onChange"])
          ], 4),
          _createElementVNode("div", {
            class: "section-card",
            style: _normalizeStyle({ background: _ctx.isLight ? '#ffffff' : '#1F1F1FB2' })
          }, [
            _createElementVNode("div", {
              class: "card-step",
              style: _normalizeStyle({ color: _ctx.isLight ? '#1a1a1a' : '#D8D8DF' })
            }, "第四步：仓位控制", 4),
            _createVNode(_component_PositionControl, {
              "is-light": _ctx.isLight,
              colors: _ctx.colors,
              "initial-value": _ctx.watchwordData,
              onChange: _ctx.onPositionChange
            }, null, 8, ["is-light", "colors", "initial-value", "onChange"])
          ], 4),
          _createElementVNode("div", {
            class: "section-card",
            style: _normalizeStyle({ background: _ctx.isLight ? '#ffffff' : '#1F1F1FB2' })
          }, [
            _createElementVNode("div", {
              class: "card-step",
              style: _normalizeStyle({ color: _ctx.isLight ? '#1a1a1a' : '#D8D8DF' })
            }, "第五步：回测周期", 4),
            _createVNode(_component_BacktestPeriod, {
              "is-light": _ctx.isLight,
              colors: _ctx.colors,
              "com-options": _ctx.comOptions,
              "initial-value": _ctx.backtestPeriodInitial,
              "default-period": "year1",
              onChange: _ctx.onBacktestChange
            }, null, 8, ["is-light", "colors", "com-options", "initial-value", "onChange"])
          ], 4)
        ]),
        _createElementVNode("div", {
          class: "summary-bar",
          style: _normalizeStyle({ background: _ctx.isLight ? '#ffffff' : '#1a1a1a', borderTopColor: _ctx.isLight ? '#f0f0f0' : 'rgba(255,255,255,0.08)' })
        }, [
          _createElementVNode("div", {
            class: "summary-title",
            style: _normalizeStyle({ color: _ctx.colors.textPrimary })
          }, "策略摘要", 4),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", {
                  class: "summary-label",
                  style: _normalizeStyle({ color: _ctx.colors.textMuted })
                }, "选股因子：", 4),
                _createElementVNode("span", {
                  class: "summary-value summary-factor-val",
                  style: _normalizeStyle({ color: _ctx.colors.textPrimary, cursor: _ctx.selectedFactors.length ? 'pointer' : 'default' }),
                  onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedFactors.length && (_ctx.showFactorTip = true))),
                  onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showFactorTip = false))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.selectedFactors.length ? `${_ctx.selectedFactors.length}个` : '—'), 1),
                  (_ctx.showFactorTip && _ctx.selectedFactors.length)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "factor-tip",
                        style: _normalizeStyle({ background: _ctx.isLight ? '#fff' : '#2a2a2a', borderColor: _ctx.colors.border })
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFactors, (f) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: f.attrCode,
                            class: "factor-tip-item",
                            style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                          }, _toDisplayString(f.attrName), 5))
                        }), 128))
                      ], 4))
                    : _createCommentVNode("", true)
                ], 36)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", {
                  class: "summary-label",
                  style: _normalizeStyle({ color: _ctx.colors.textMuted })
                }, "买入时机：", 4),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.tradingData.buyPriorityLabel ? `T+1开盘；${_ctx.tradingData.buyPriorityLabel}` : '—'), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", {
                  class: "summary-label",
                  style: _normalizeStyle({ color: _ctx.colors.textMuted })
                }, "仓位控制：", 4),
                _createElementVNode("span", {
                  class: "summary-value",
                  style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                }, _toDisplayString(_ctx.positionSummary || '—'), 5)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", {
                  class: "summary-label",
                  style: _normalizeStyle({ color: _ctx.colors.textMuted })
                }, "选股范围：", 4),
                _createElementVNode("span", {
                  class: "summary-value",
                  style: _normalizeStyle({ color: _ctx.colors.textPrimary, cursor: _ctx.selectedRanges.length ? 'pointer' : 'default' }),
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onOpenSelectedStockDialog && _ctx.onOpenSelectedStockDialog(...args)))
                }, [
                  (!_ctx.selectedRanges.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_18
                      ], 64))
                    : (_ctx.rangeStockLoading)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_19
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(_ctx.rangeStockTotal) + "只", 1)
                        ], 64)),
                  (_ctx.selectedRanges.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, "已选股票"))
                    : _createCommentVNode("", true)
                ], 4)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("span", {
                  class: "summary-label",
                  style: _normalizeStyle({ color: _ctx.colors.textMuted })
                }, "卖出时机：", 4),
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.sellSummary || '—'), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("span", {
                  class: "summary-label",
                  style: _normalizeStyle({ color: _ctx.colors.textMuted })
                }, "回测周期：", 4),
                _createElementVNode("span", {
                  class: "summary-value",
                  style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                }, _toDisplayString(_ctx.backtestData.periodLabel || '—'), 5),
                _createElementVNode("button", {
                  class: _normalizeClass(["backtest-btn", { 'btn-disabled': _ctx.backtesting }]),
                  disabled: _ctx.backtesting,
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleBacktest && _ctx.handleBacktest(...args)))
                }, "一键回测", 10, _hoisted_24)
              ])
            ])
          ])
        ], 4),
        (_ctx.showStockDialog)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "dialog-mask",
              onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.showStockDialog = false), ["self"]))
            }, [
              _createElementVNode("div", {
                class: "stock-dialog",
                style: _normalizeStyle({ background: _ctx.isLight ? '#fff' : '#1f1f1f' })
              }, [
                _createElementVNode("div", {
                  class: "stock-dialog-header",
                  style: _normalizeStyle({ borderBottomColor: _ctx.isLight ? '#f0f0f0' : 'rgba(255,255,255,0.08)' })
                }, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                  }, "已选股票（" + _toDisplayString((_ctx.rangeStockLoading || _ctx.rangeDialogListLoading) ? '…' : `${_ctx.rangeStockTotal}只`) + "）", 5),
                  _createElementVNode("span", {
                    class: "dialog-close",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showStockDialog = false)),
                    style: _normalizeStyle({ color: _ctx.colors.textMuted })
                  }, "✕", 4)
                ], 4),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("table", _hoisted_26, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", {
                          style: _normalizeStyle({ color: _ctx.colors.textMuted })
                        }, "序", 4),
                        _createElementVNode("th", {
                          style: _normalizeStyle({ color: _ctx.colors.textMuted })
                        }, "代码", 4),
                        _createElementVNode("th", {
                          style: _normalizeStyle({ color: _ctx.colors.textMuted })
                        }, "名称", 4),
                        _createElementVNode("th", {
                          style: _normalizeStyle({ color: _ctx.colors.textMuted })
                        }, "最新", 4),
                        _createElementVNode("th", {
                          style: _normalizeStyle({ color: _ctx.colors.textMuted })
                        }, "涨幅", 4)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_ctx.rangeDialogListLoading)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                            _createElementVNode("td", {
                              colspan: "5",
                              style: _normalizeStyle({ color: _ctx.colors.textMuted, textAlign: 'center' })
                            }, "加载中…", 4)
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rangeStockList, (s, i) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: `${s.market || ''}-${s.symbol || i}`
                              }, [
                                _createElementVNode("td", {
                                  style: _normalizeStyle({ color: _ctx.colors.textMuted })
                                }, _toDisplayString(i + 1), 5),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                                }, _toDisplayString(_ctx.formatStockCode(s)), 5),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                                }, _toDisplayString(s.name || '—'), 5),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                                }, _toDisplayString(_ctx.formatPrice(s.lastPx)), 5),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({ color: _ctx.pxRateColor(s.pxChangeRate) })
                                }, _toDisplayString(_ctx.formatPct(s.pxChangeRate)), 5)
                              ]))
                            }), 128)),
                            (!_ctx.rangeStockList.length && _ctx.selectedRanges.length)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                                  _createElementVNode("td", {
                                    colspan: "5",
                                    style: _normalizeStyle({ color: _ctx.colors.textMuted, textAlign: 'center' })
                                  }, "暂无命中股票", 4)
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                    ])
                  ])
                ])
              ], 4)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showToast)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.toastMsg), 1))
          : _createCommentVNode("", true),
        (_ctx.backtesting)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createVNode(_component_a_spin, {
                tip: "回测中，请稍候...",
                size: "large"
              })
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_StarTipDialog, {
          tipDialog: _ctx.tipDialog,
          unlock: _ctx.unlock,
          onUnlockClose: _ctx.handleUnlockClose,
          onUnlockBannerClick: _ctx.handleUnlockBannerClick,
          onUnlockShareClose: _ctx.handleUnlockShareClose,
          onUnlockPromoClose: _ctx.handleUnlockPromoClose,
          onUnlockPurchaseClick: _ctx.handleUnlockPurchaseClick
        }, null, 8, ["tipDialog", "unlock", "onUnlockClose", "onUnlockBannerClick", "onUnlockShareClose", "onUnlockPromoClose", "onUnlockPurchaseClick"]),
        _createVNode(_component_StarActivationDialog, {
          visible: _ctx.showActivationDialog,
          "show-qr": _ctx.showActivationQr,
          onActivate: _ctx.openActivationQr,
          onRefresh: _cache[8] || (_cache[8] = () => _ctx.refreshActivation(_ctx.route, _ctx.starUserName)),
          onClose: _ctx.hideActivation
        }, null, 8, ["visible", "show-qr", "onActivate", "onClose"])
      ], 4)
    ]),
    _: 1
  }))
}